import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import { LegalPage } from "@/components/site/LegalPage";
import { PRIVACY_POLICY, TERMS } from "@/lib/legal";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<LegalPage doc={PRIVACY_POLICY} testid="privacy-page" />} />
          <Route path="/terms" element={<LegalPage doc={TERMS} testid="terms-page" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
